import { useEffect, useState } from "react";
import moment from "moment";
import cn from "classnames";

import { IPlayersProps } from "./Players";
import { useStyles } from "./styles";
import LoadingDots from "src/pages/game-new2/components/loadingDots";

export interface ISearching {
    elementPosition?: string;
}

export const Searching = ({
    createdAt,
    elementPosition,
}: Pick<IPlayersProps, "createdAt"> & ISearching) => {
    const classes = useStyles();
    const [timerEnd, setTimer] = useState<number>(0);

    const nowDate = moment().valueOf();
    const createdTime = moment(createdAt).valueOf();
    const threeMinutes = 180000;
    const tenSeconds = 30000;
    const threeSeconds = 3000;
    const intervalTime = 1000;

    useEffect(() => {
        if (createdAt) {
            let timer = setInterval(() => {
                const data =
                    nowDate - createdTime < threeMinutes
                        ? threeMinutes - (nowDate - createdTime)
                        : 0;
                setTimer(data);
            }, intervalTime);
            return () => {
                clearInterval(timer);
            };
        }
        setTimer(0);
    }, [timerEnd]);

    if (createdAt!)
        return (
            <div className={classes.wrapperSeachingPlayers}>
                <span className={classes.searchingText}>
                    <p>Searching...</p>
                    {/* <span
                        className={cn(classes.searchTimeoutText, {
                            info: timerEnd <= tenSeconds,
                            warning: timerEnd <= threeSeconds,
                        })}
                    >
                        {timerEnd > 100 ? (
                            moment.utc(timerEnd).format("mm:ss")
                        ) : (
                            <>
                                <LoadingDots
                                    size={16}
                                    color="#00BA6C"
                                    time={0.05}
                                    delay={0.5}
                                    className={classes.centred}
                                    stopped={false}
                                />
                            </>
                        )}
                    </span> */}
                </span>
            </div>
        );
};
